import styled from 'styled-components'
import { base } from '../../../styles/themes.jsx'
import { widgetFont } from '../widgetTypography'

const MOBILE = '@media (max-width: 480px)'

export const ScrollContainer = styled.div`
  flex: 1;
  overflow-y: auto;
  scrollbar-gutter: stable;
  min-height: 0;
  padding: ${base.space[4]};
`

export const Grid = styled.div`
  display: grid;
  grid-template-columns: ${({ $cols }) => $cols};

  ${MOBILE} {
    display: block;
  }
`

export const HeaderCell = styled.div`
  background: ${p => p.theme.table.header};
  color: ${p => p.theme.font.label};
  ${widgetFont.label}
  font-weight: 700;
  padding: ${base.space[3]} ${base.space[4]};
  border-bottom: 1px solid ${p => p.theme.table.border};

  ${MOBILE} {
    display: none;
  }
`

export const DataRow = styled.div`
  display: contents;
  cursor: ${p => p.$clickable ? 'pointer' : 'default'};

  &:hover > div {
    background: ${p => p.theme.table.hover};
  }

  ${MOBILE} {
    display: block;
    border: 1px solid ${p => p.theme.table.border};
    border-radius: ${base.space[3]};
    margin-bottom: ${base.space[3]};
    overflow: hidden;
  }
`

export const Cell = styled.div`
  color: ${p => p.theme.font.color};
  ${widgetFont.body}
  padding: ${base.space[3]} ${base.space[4]};
  border-top: 1px solid ${p => p.theme.table.borderTop};

  ${MOBILE} {
    display: flex;
    justify-content: space-between;
    align-items: baseline;
    gap: ${base.space[3]};
    border-top: 1px solid ${p => p.theme.table.borderTop};

    &::before {
      content: attr(data-label);
      color: ${p => p.theme.font.label};
      ${widgetFont.caption}
      font-weight: 600;
      flex-shrink: 0;
    }

    &:first-child {
      ${widgetFont.body}
      font-weight: 700;
      border-top: none;
      background: ${p => p.theme.table.header};

      &::before {
        display: none;
      }
    }
  }
`

export const EmptyCell = styled.div`
  grid-column: 1 / -1;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: ${base.space[3]};
  text-align: center;
  color: ${p => p.theme.font.label};
  ${widgetFont.body}
  padding: ${base.space[5]};
`
